import { getStore, setStore } from './utils/store'
import connect from './connect/connect'
import Provider from './connect/Provider'

export default {
  connect,
  Provider,
  getStore,
  setStore
}

export {
  connect,
  Provider,
  getStore,
  setStore
}
